import api from "../utils/api";
import { LOGOUT } from "./types";

export const list = () => async (dispatch) => {
    try {
        const res = await api.get(`/rates`);
        return res.data?.items || [];
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const save = ({ uuid, code, name, index, value, style }) => async (dispatch) => {
    try {
        const res = await api.post(`/rates`, { uuid, code, name, index, value, style });
        return res.data;
    } catch (error) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const get = ({ uuid, style }) => async (dispatch) => {
    try {
        const res = await api.get(`/rates/${uuid ? 'i/'+uuid : 's/' + style}`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const move = ({ uuid, ordinal }) => async (dispatch) => {
    try {
        const res = await api.get(`/rates/i/${uuid}/m/${ordinal}`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}


export const destroy = ( uuid ) => async (dispatch) => {
    try {
        const res = await api.delete(`/rates/i/${uuid}`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}
